import {
  userDetailsCss,
  userEmailText,
  userNameTextCss,
  userPopoutContainerCss,
  userRoleTextCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfilePopout/PopoutUserInformation/PopoutUserInformation.styles";
import { getIsLiteUser } from "@/base/NewselaGlobalLayoutV2/NavigationBar/UserProfileMenu/UserProfileMenu.utils";
import { getRoleLabel } from "@/users/getRoleLabel";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

const PopoutUserInformation = () => {
  const { data: user } = useUser();
  const { hasAccessToLite, hasNceTrialCampaign, isImpersonated } =
    getUserProperties(user, { shouldUseNewUserApi: false });
  const isLite = getIsLiteUser(
    hasAccessToLite,
    hasNceTrialCampaign,
    user?.licenses,
  );
  const roleLabel = getRoleLabel(user);

  return (
    <div css={userPopoutContainerCss(isLite, isImpersonated)}>
      <div css={userNameTextCss} data-qa-selector="global-nav-user-name">
        {isImpersonated ? "Impersonating: " : ""}
        {user.name}
      </div>
      <div css={userDetailsCss}>
        {roleLabel && (
          <div css={userRoleTextCss} data-qa-selector="global-nav-user-role">
            {roleLabel}
          </div>
        )}
        <div css={userEmailText} data-qa-selector="global-nav-user-email">
          {user.email}
        </div>
      </div>
    </div>
  );
};

PopoutUserInformation.displayName = "PopoutUserInformation";
export { PopoutUserInformation };
